import type { RefObject } from 'react';
import { AccountContentPicker } from '../library/picker/AccountContentPicker';
import { postToCrm, toFrameRow, type FramePickedMedia, type FrameVaultRow } from './crmBridge';

export interface FramePickRequest {
  requestId: string;
  accountId: string;
  initial: FramePickedMedia[];
}

/**
 * The console's content picker opened for a CRM frame page (Mass messages,
 * the old Chats): what is picked goes back to the frame, which attaches it
 * as if its own picker had.
 */
export function FrameContentPicker({ request, frameRef, onEnd }: { request: FramePickRequest; frameRef: RefObject<HTMLIFrameElement | null>; onEnd: () => void }) {
  const answer = (items: FrameVaultRow[] | null) => {
    postToCrm(frameRef.current, { type: 'crm:content-picked', requestId: request.requestId, items });
    onEnd();
  };
  return (
    <AccountContentPicker
      key={request.requestId}
      accountId={request.accountId}
      initial={request.initial}
      onDone={(items) => answer(items.map(toFrameRow))}
      onClose={() => answer(null)}
    />
  );
}
